import React, { useEffect } from 'react';
import './contratos.css';
import { contratos } from '../../json/contratos.js';

const Contratos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Contratos</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      {contratos.map((tipoContrato, index) => (
        <div key={index} className='row'>
          <div className='col-12 container-armon'>
            <div className='armo-collapse'>
              <h5><strong>{tipoContrato.tipcontrato}</strong></h5>
              <div className="row">
                {tipoContrato.elementos.map((contrato, idx) => (
                  <div key={idx} className="col-md-4">
                    <a
                      href={contrato.pdfLink}
                      target='_blank'
                      rel='noopener noreferrer'
                      style={{ fontWeight: 'normal' }}
                      className='span'>
                      {contrato.title}
                    </a><hr className='row-separator' />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div> 
  );
};

export default Contratos;
